<template>
    <div class="content-two-columns">
        <div class="column left-column">
            <div class="column-wrapper">
                <ContentComponentItem
                    v-for="(component, key) in data.leftColumnContent"
                    :key="key"
                    :background="data.leftColumnBackgroundColor"
                    :data="component"
                />
            </div>
        </div>

        <div class="column right-column">
            <div class="column-wrapper">
                <ContentComponentItem
                    v-for="(component, key) in data.rightColumnContent"
                    :key="key"
                    :background="data.rightColumnBackgroundColor"
                    :data="component"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ComponentContentTwoColumnsFragment } from '@/graphql/api'
import type { ButtonColors } from '@/components/ui/buttons'
import { cmsColorToButtonColor } from '@/components/cms'

import ContentComponentItem from '@/components/cms/component/ContentComponentItem.vue'

const props = defineProps<{
    data: ComponentContentTwoColumnsFragment
}>()

const leftColumnBackground = computed(
    (): ButtonColors =>
        cmsColorToButtonColor(props.data.leftColumnBackgroundColor)
)

const rightColumnBackground = computed(
    (): ButtonColors =>
        cmsColorToButtonColor(props.data.rightColumnBackgroundColor)
)
</script>

<style lang="scss" scoped>
.content-two-columns {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;

    @include min-width(768) {
        display: flex;
        align-items: center;
    }

    .left-column {
        background: v-bind(leftColumnBackground);
    }

    .right-column {
        background: v-bind(rightColumnBackground);
    }

    .column-wrapper {
        align-self: center;
    }

    .column {
        width: 100%;
        padding: 20px;
        align-self: stretch;
        display: flex;

        @include min-width(768) {
            padding: 40px 100px 20px;
            width: 50%;
            flex-shrink: 0;
        }
    }
}
</style>
